import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';
import {
  ScopeBundle,
  ScopeBundleCreate,
  ScopeBundleReview,
  ScopeBundleUpdate,
} from '@frontend/types';

const TOOLS_MANAGEMENT_URL = `${OPAL_URL}/tools-mgmt-service`;

export const getScopeBundles = (providerId?: string) => {
  const queryParams = providerId ? `?provider_id=${providerId}` : '';
  const key = ['scope-bundles', providerId || 'all'];
  return {
    key,
    queryFn: async () => {
      const response = await http.get<ScopeBundle[]>(
        `${TOOLS_MANAGEMENT_URL}/api/auth/scope-bundles${queryParams}`
      );
      return response.data;
    },
  };
};

export function createScopeBundle(payload: ScopeBundleCreate) {
  return http.post<ScopeBundle>(`${TOOLS_MANAGEMENT_URL}/api/auth/scope-bundles/request`, payload);
}

export function updateScopeBundle(bundleId: string, payload: ScopeBundleUpdate) {
  return http.put<ScopeBundle>(
    `${TOOLS_MANAGEMENT_URL}/api/auth/scope-bundles/${bundleId}`,
    payload
  );
}

export function deleteScopeBundle(bundleId: string) {
  return http.delete(`${TOOLS_MANAGEMENT_URL}/api/auth/scope-bundles/${bundleId}`);
}

export function reviewScopeBundle(bundleId: string, payload: ScopeBundleReview) {
  return http.post(
    `${TOOLS_MANAGEMENT_URL}/api/auth/admin/scope-bundles/${bundleId}/review`,
    payload
  );
}
